<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Enviar orçamento"
    type-modal="send_quotation_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="print()">

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>E-mail</label>
            <d-form-input type="email" id="feInputFooter" v-model="model.email" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Message -->
          <d-col md="12" class="form-group">
            <label>Mensagem de envio</label>
            <editor ref="recibo" :model.sync="model.sendMessage"/>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="send()"
        class="btn btn-sm btn-primary"
      >Enviar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinFormatMessage from '_common/mixins/FormatMessage';
import { MODEL, _OPEN_MODAL_ } from '../QuotationModel';

export default {
  name: 'send-email',
  data() {
    return {
      loading: false,
      model: {
        email: '',
        sendMessage: '',
      },
      quotation: { ...MODEL },
    };
  },
  mixins: [MixinFormatMessage],
  components: {
    Editor,
    ModalTemplate,
  },
  computed: {
    messages() {
      const { messages } = this.$store.state.settings;
      if (messages) {
        return messages;
      }
      return { sendMessage: '' };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getSettings',
    ]),
    formatMessages() {
      const message = this.setCustomerMessage(this.messages.sendMessage, this.quotation.customer);
      this.model.email = this.quotation.customer.email;
      this.model.sendMessage = message;
    },
    getSettingsSystem() {
      this.setToggle({ type: 'progress', bool: true });
      this.getSettings()
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    send() {
      this.setToggle({ type: 'progress', bool: true });
      const params = { message: this.model.sendMessage, email: this.model.email, quotation_id: this.quotation.id };
      QuotationService.sendMessage(params)
        .then(() => {
          this.setToggle({ type: 'send_quotation_modal', bool: false });
          this.activeAlert({ message: 'Orçamento enviado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, ({ quotation, type }) => {
      if (type === 'send_quotation_modal') {
        this.quotation = quotation;
        if (this.quotation) {
          this.formatMessages();
        }
      }
    });
    if (this.$store.state.settings.messages == null) {
      this.getSettingsSystem();
    }
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
